import { sprintf, __ } from '@wordpress/i18n';
import { registerPaymentMethod } from '@woocommerce/blocks-registry';
import { decodeEntities } from '@wordpress/html-entities';
import { getSetting } from '@woocommerce/settings';

import PayPalPayment from './Components/PayPalPayment';
import { PAYMENT_METHOD_NAME } from './contants';
import { useEffect } from '@wordpress/element';

const settings = getSetting( 'dokan_paypal_marketplace_data', {} );

const defaultLabel = __( 'PayPal Marketplace Payments', 'dokan' );

const label = decodeEntities( settings.title ) || defaultLabel;

const hidePlaceOrderButton = ( hide ) => {
    const btn = document.querySelector(
        '.wc-block-components-checkout-place-order-button'
    ) as HTMLElement | null;

    if ( ! btn ) {
        return;
    }

    btn.style.visibility = hide ? 'hidden': 'inherit';
};

/**
 * Content component
 */
const Content = ( props ) => {
    /**
     * When a customer chooses the PayPal marketplace payment gateway, we are hiding the woocommerce `Place Order` button
     * so that we can force customer to pay and place order by clicking PayPal pay button.
     * And again, when the customer chooses
     * another payment button, we are showing back the default `Place Order button`.
     */
    useEffect(() => {
        hidePlaceOrderButton(true);

        // Cleanup function
        return () => {
            hidePlaceOrderButton(false);
        };
    }, []);

    return (
        <div>
            { decodeEntities( settings.description || 'Testing Dokan PayPal' ) }

            { <PayPalPayment config={ settings } { ...props } /> }
        </div>
    );
};
/**
 * Label component
 *
 * @param {*} props Props from payment API.
 */
const Label = ( props ) => {
    const { PaymentMethodLabel } = props.components;
    return <PaymentMethodLabel text={ label } />;
};

/**
 * Dummy payment method config object.
 */
const DokanPaypalMarketPlace = {
    name: PAYMENT_METHOD_NAME,
    label: <Label />,
    content: <Content />,
    edit: <Content />,
    canMakePayment: () => true,
    ariaLabel: label,
    supports: {
        features: settings.supports,
    },
};

registerPaymentMethod( DokanPaypalMarketPlace );
